<template>
  <div class="lp-check-group-container">
    <div class="lp-check-container" v-for="(item, idx) in list" :key="'chk'+idx" @click="clickCheck(item)">
      <div class="sel-btn" :class="{'selected': isSelected(item) }">
        <i v-if="isSelected(item)" class="material-icons checked-icon">check</i>
      </div>
      <div class="lp-label">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list: {
        type: Array
      }
    },
    created() {
    },
    data() {
      return {
      }
    },
    watch: {
    },
    methods: {
      clickCheck(item) {
        item.is_active? item.is_active = false: item.is_active = true;
        this.$emit('selectedItem', item);
      },
      isSelected(item) {
        if( item.is_active ) return true;
        else return false;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_variable'
  .lp-check-group-container
    display grid
    grid-template-columns repeat(4, 1fr)
    grid-column-gap 8px
    grid-row-gap 4px

  .lp-check-container
    cursor pointer
    display flex
    align-items center

  .sel-btn
    width 16px
    height 16px
    border-radius 3px
    margin auto 0
    margin-right 8px
    border 1px solid #dddddd
    background-color white
    display inline-block
    text-align center

  .selected
    background-color $primary
    border 1px solid $primary

  .checked-icon
    color #fff
    font-size .8rem
    font-weight bold
    padding 1.5px
    display flex
    align-items center
    justify-content center

  .lp-label
    font-size 0.9rem
    line-height 17px

</style>
